import ChangePasswordPage from './ChangePasswordPage'

export default ChangePasswordPage
